import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { SubirArchivos_Usuario, SubirArchivos_Usuario_Archivos } from '../models/generic/SubirArchivos_Usuario';
import { HeaderAdicionales } from '../models/generic/HeaderDatos';
import { stringify } from '@angular/compiler/src/util';

@Injectable({
  providedIn: 'root'
})
export class SubirArchivosUsuarioService {
  
  ListaDirectorios: SubirArchivos_Usuario[] = [];
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  Consultar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_USUARIO_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarSubDirectorio(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_SUBDIRECTORIOS_DIRECTORIO_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarArchivos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_USUARIO_CONSULTARARCHIVOS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  EliminarArchivos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_USUARIO_ELIMINARARCHIVOS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  DescargarArchivos(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_USUARIO_DESCARGARARCHIVOS()}`;
    return this.comunicacionapiService.PostDescarga(urlServicio, parametros);
  }
  CrearDirectorio(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_USUARIO_CREARDIRECTORIO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ImportarArchivos(archivo: any, parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.SUBIRARCHIVOS_USUARIO_IMPORTARARCHIVOS()}`;
    let listaHeaders: HeaderAdicionales[] = [];
    listaHeaders.push({codigo: 'datosimportar', valor: JSON.stringify(parametros)});
    return this.comunicacionapiService.Post(urlServicio, archivo, true, listaHeaders);
  }
}
